"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsageService = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const shared_1 = require("../../shared");
const http_1 = require("@angular/common/http");
class UsageService extends shared_1.RestService {
    constructor() {
        super(...arguments);
        this.usageDetailsUrl = '/rest-api/account/sub/usage/v1/details/';
        this.dataUsageUrl = '/rest-api/account/sub/usage/v1/data/byPlan/';
        this.bbDataUsageUrl = '/rest-api/account/sub/usage/v1/data/business/';
        this.dataUsageHistoryUrl = '/rest-api/account/sub/usage/v1/history/';
        this.bbdataUsageReport = '/rest-api/email/v1/business/usagereport';
        this.businessUsageUrl = '/rest-api/account/sub/usage/v1/business/data/';
        this.bbusageGenerateUrl = '/rest-api/account/sub/usage/v1/business/billgenerate/data/';
        this.checkDataPlanUrl = '/rest-api/account/sub/usage/v1/check-data-plan/';
        // CIP:209 - get Data passes url
        this.getDataPassesUrl = '/rest-api/account/sub/v1/datapasses?subId=';
        this.validateBillToAccountUrl = '/global/checkoutController.jsp?action=validateBillToAccount';
        this.getBTADetailsUrl = '/global/checkoutController.jsp?action=getBillToAccountDetails';
    }
    getUsageDetails(subscriptionId, billDate) {
        if (billDate !== undefined && billDate !== null) {
            return this.get(this.usageDetailsUrl + subscriptionId + '/' + billDate).pipe(operators_1.map((data) => data));
        }
        else {
            return this.get(this.usageDetailsUrl + subscriptionId + '/').pipe(operators_1.map((data) => data));
        }
    }
    getDataUsage(subscriptionId) {
        if (subscriptionId != null && subscriptionId !== undefined) {
            return this.get(this.dataUsageUrl + subscriptionId).pipe(operators_1.map((data) => data));
        }
        else {
            return this.get(this.dataUsageUrl).pipe(operators_1.map((data) => data));
        }
    }
    getBbDataUsage(planName) {
        // if (planName != null && planName !== undefined) {
        return this.get(this.bbDataUsageUrl + planName).pipe(operators_1.map((data) => data));
    }
    getDataUsageHistory(subscriptionId) {
        return this.get(this.dataUsageHistoryUrl + subscriptionId + '/3/').pipe(operators_1.map((data) => data));
    }
    bbDataUsageGetReport(updateReport) {
        const inputArgs = new http_1.HttpParams().set('updateReport', updateReport);
        return this.post(this.bbdataUsageReport, inputArgs).pipe(operators_1.map((data) => data));
    }
    getBusinessDataUsage(subscriptionId) {
        return this.get(this.businessUsageUrl + subscriptionId).pipe(operators_1.map((data) => data));
    }
    getBusinessUsageReport(generateReport) {
        return this.get(this.bbusageGenerateUrl + generateReport).pipe(operators_1.map((data) => data));
    }
    checkDataPlan(subscriptionId) {
        return this.get(this.checkDataPlanUrl + subscriptionId + '/').pipe(operators_1.map((data) => data));
    }
    /**
   * CIP:209 - get data passes
   *
   */
    getAllDataPasses(subId) {
        return this.get(this.getDataPassesUrl + subId).pipe(operators_1.map((data) => data));
    }
    /**
    * CIP:209 - validate account for BTA eligibility
    */
    validateBillToAccount() {
        return this.get(this.validateBillToAccountUrl).pipe(operators_1.map((data) => data));
    }
    /**
     * CIP:209 - validate account for BTA eligibility
     */
    getBTADetails() {
        return this.get(this.getBTADetailsUrl).pipe(operators_1.map((data) => data));
    }
}
exports.UsageService = UsageService;
//# sourceMappingURL=usage.service.js.map